export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-w.d67cf46d.webp";